import Homepage from "./pages/Homepage";

export default function App() {
  return (
    <Homepage />
  );
}
